import createMarkup from "../../utils/createMarkup";

type DangerousProps = {
  children: React.ReactNode;
  className?: string;
};

export const H1 = ({ children, ...props }: DangerousProps & { ref?: React.Ref<HTMLHeadingElement> }) => (
  <h1 {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const H2 = ({ children, ...props }: DangerousProps) => (
  <h2 {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const H3 = ({ children, ...props }: DangerousProps) => (
  <h3 {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const H4 = ({ children, ...props }: DangerousProps) => (
  <h4 {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const H5 = ({ children, ...props }: DangerousProps) => (
  <h5 {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const P = ({ children, ...props }: DangerousProps) => (
  <p {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const Span = ({ children, ...props }: DangerousProps) => (
  <span {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const B = ({ children, ...props }: DangerousProps) => (
  <b {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const Blockquote = ({ children, ...props }: DangerousProps) => (
  <blockquote {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const A = ({ children, ...props }: DangerousProps) => (
  <a {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const Li = ({ children, ...props }: DangerousProps) => (
  <li {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const Ul = ({ children, ...props }: DangerousProps) => (
  <ul {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);

export const Div = ({ children, ...props }: DangerousProps) => (
  <div {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);
